<template>
  <div class="register-page">
    <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <div class="form-header">{{$t('policy.header')}}</div>
      <div class="form-group">

        Có hiệu lực cho tất cả các khách hàng, cả khách hàng chính thức và khách hàng dùng thử
        <br><br>
        CHẤP NHẬN ĐIỀU KHOẢN
        <br><br>
        Công ty TNHH Viễn thông ePacific (gọi tắt là ePacific Telecom) xây dựng và duy trì trang web www.ccall.vn như một công cụ cung cấp thông tin và dịch vụ cho khách hàng và người sử dụng Internet. Khi truy cập bất cứ trang web nào thuộc về sở hữu của ePacific Telecom bao gồm:
        <br><br>
        – www.ccall.vn,<br>
        – www.ccall.io,<br>
        – các trang trong của tên miền *.ccall.vn và *.ccall.io và *.epacific.com.vn<br>
        <br>
        điều đó có nghĩa là người sử dụng đồng ý với các điều khoản, điều kiện quy định của ePacific Telecom.
        <br><br>
        Nếu khách hàng không đồng ý với các điều khoản và điều kiện này thì người sử dụng nên chấm dứt sử dụng các trang web này. Tất cả thông tin trên các trang web này chỉ được sử dụng cho mục đích cá nhân, cấm không được sử dụng cho các mục đích thương mại mà không được sự đồng ý trước của ePacific Telecom bằng văn bản.
        <br><br>
        ĐIỀU KIỆN SỬ DỤNG
        <br><br>
        Chúng tôi có thể chỉnh sửa, cập nhật các quy định và điều kiện này bất cứ lúc nào mà không cần báo trước. Việc chỉnh sửa này sẽ có hiệu lực ngay khi được cập nhật trên website của ePacific Telecom. Khách hàng cần thường xuyên kiểm tra các thay đổi này và việc khách hàng tiếp tục sử dụng các trang web này đồng nghĩa với việc đồng ý với các nội dung đã thay đổi đó.<br><br>

        ĐĂNG KÝ SỬ DỤNG, MẬT KHẨU TRUY CẬP, BẢO MẬT<br><br>

        Nếu có 1 bộ phận trên trang web yêu cầu khách hàng đăng ký hoặc mở 1 tài khoản truy nhập, khách hàng cần cung cấp cho ePacific Telecom các thông tin chính xác, đầy đủ và mới nhất. Khi được yêu cầu tự chọn mật khẩu truy cập, hãy chọn mật khẩu mà không ai khác có thể đoán được, mật khẩu nên kết hợp cả số và kí tự và nên có độ dài ít nhất 6 kí tự.<br><br>

        Sau khi đăng ký, khách hàng không nên tiết lộ mật khẩu cho bất kỳ ai khác, không được ủy quyền hoặc cho phép bất cứ ai khác sử dụng tên và mật khẩu truy cập của mình vào bất cứ mục đích nào.<br><br>

        Việc tên và mật khẩu truy cập của khách hàng được sử dụng để truy cập và sử dụng trang web ePacific Telecom sẽ được chúng tôi coi như chính khách hàng đó đã truy nhập và sử dụng dịch vụ bất kể việc tên và mật khẩu truy cập của khách hàng bị người khác sử dụng mà chủ sở hữu không biết hoặc không cho phép.<br><br>

        Khi phát hiện ra bất cứ ai biết hoặc hoặc sử dụng mật khẩu của mình để truy nhập và sử dụng trang web của ePacific Telecom, khách hàng cần:<br><br>

        – Thông báo ngay lập tức cho ePacific Telecom.<br>

        – Cung cấp cho ePacific Telecom các thông tin được yêu cầu.<br>

        – Thay đổi ngay mật khẩu truy nhập hoặc yêu cầu ePacific Telecom hỗ trợ thay đổi mật khẩu.<br>
        <br>
        ePacific Telecom hoặc các đại diện của mình hoặc các đại lý, các nhân viên sẽ không phải chịu trách nhiệm đối với bất kỳ Khách hàng nào về bất kỳ sự thiếu chính xác, sai sót, gián đoạn, sự đúng lúc, tính hoàn thiện, sự xóa bỏ, nhược điểm, mất hiệu năng, virus máy tính, trục trặc đường liên lạc, sự thay đổi hoặc sử dụng bất kỳ thông tin nào ở đây, vì bất kỳ nguyên nhân gì, đối với bất kỳ thiệt hại nào.<br><br>

        QUYỀN THU THẬP VÀ SỬ DỤNG THÔNG TIN<br><br>

        Khi khách hàng truy nhập và sử dụng trang web của ePacific Telecom có thể thu thập và lưu trữ các thông tin như các số liệu thống kê quá trình truy cập, các thông tin cá nhân cung cấp cho ePacific Telecom khi đăng ký… Các thông tin cá nhân khách hàng cung cấp bao gồm nhưng không giới hạn bởi tên, ngày sinh, số điện thoại, địa chỉ email, địa chỉ thường trú, địa chỉ thanh toán phí… Chúng tôi có quyền sử dụng các thông tin này vào việc lập kế hoạch, nghiên cứu, thiết kế và tuyên truyền các dịch vụ hoặc cung cấp thông tin cho các cơ quan pháp luật theo yêu cầu của Luật pháp hoặc của Toà án.<br><br>

        QUY ĐỊNH VỀ NỘI DUNG THÔNG TIN<br><br>

        Tất cả các thông tin gửi, nhận qua dịch vụ các dịch vụ của ePacific Telecom như cuộc gọi điện thoại, tin nhắn SMS, văn bản, Email, Chat đều mang tính riêng tư, vì vậy ePacific Telecom sẽ không kiểm soát nội dung truyền qua hệ thống phần mềm dịch vụ của ePacific Telecom (portal).<br><br>

        Khách hàng phải tự chịu trách nhiệm với bất cứ nội dung nào đưa lên hoặc truyền tải qua hệ thống phần mềm dịch vụ của ePacific Telecom hoặc với người sử dụng trang web với bất cứ mục đích gì.<br><br>

        Khách hàng đồng ý sử dụng Portal ePacific Telecom trong khuôn khổ phù hợp với các quy định và luật pháp hiện hành và cam kết không sử dụng Portal để đưa lên, truyền tải, phân phối, liên kết các nội dung:<br><br>

        – Chứa các thông điệp quảng cáo vi phạm các điều luật, quy định của Chính phủ Việt Nam.<br>

        – Vi phạm các quy định về bản quyền, nhãn hiệu, sở hữu trí tuệ, quyền sở hữu cá nhân.<br>

        – Chứa đựng các nội dung có tính khiêu dâm, kích động, phỉ báng.<br>

        – Phá hoại tính an toàn hoặc đồng nhất của Portal bao gồm việc phát tán các loại virus, Trojan… hoặc các công cụ có tính chất phá hoại như can thiệp, phá hủy hoặc bí mật ngăn chặn, chiếm quyền điều khiển hệ thống, mạng lưới.<br>

        – Chứa các nội dung ở bất cứ dạng nào gây ra các vấn đề kiện tụng cho ePacific Telecom.<br><br>

        Khách hàng không được sử dụng bất cứ phương tiện, thiết bị gì để kiểm soát hoặc sao chép các trang web hoặc các nội dung trong trang web mà không được sự đồng ý trước của ePacific Telecom bằng văn bản.<br><br>

        ePacific Telecom có toàn quyền kiểm soát, từ chối hoặc gỡ bỏ bất cứ thông tin gì vi phạm các điều khoản này, và cao hơn nữa, hủy bỏ quyền sử dụng dịch vụ ePacific Telecom của người vi phạm. Đồng thời tuỳ theo mức độ vi phạm mà người sử dụng có thể phải chịu trách nhiệm trước pháp luật.<br><br>

        LUẬT ÁP DỤNG<br><br>

        Thỏa thuận này được hiểu và thực thi theo luật của nước Cộng hòa Xã hội Chủ nghĩa Việt nam. Bất kỳ tranh chấp nào liên quan đến thỏa thuận này cần được thực hiện tại tòa án nhân dân thành phố Hồ Chí Minh.<br><br>
        
      </div>
      <div class="form-group text-center btn-submit">
          <base-button type="button" class="btn-block" @click="gotoRegister()">{{$t('policy.accept')}}</base-button>
      </div>
     
    </div>
  </div>
</template>

<script>
import BaseButton from "../components/Button.vue";

export default {
  components: {
    BaseButton
  },
  name: 'PolicyPage',
  props: {
    name: [String],
    email: [String],
    phone: [String],
    agree: [Boolean]
  },
  data() {
    return {
      msg: 'Policy CCALL',
    };
  },
  methods: {
    gotoRegister(){
      this.$router.push({name:'RegisterPage', params: {nameInput: this.name, phoneInput: this.phone, emailInput: this.email, agreeInput: this.agree}});
    }
  },
  beforeMount() {
  }
};
</script>

<style scoped="">
  .btn-block {
    width: 80% !important;
  }
  .register-page {
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PolicyPage.vue